import { JobStatus, ConnectProto } from "@racoon/api";
import { OrderRow } from "./adapters";
import { fullName, getInitials } from "~/shared/helpers";

// ─── Priority Helpers ───────────────────────────────────────────────
const PRIORITY_ORDER = { high: 3, medium: 2, low: 1 } as const;

// priorityText may be either a short key ("high") or the full enum name
// ("PICKUP_LOCATION_PRIORITY_HIGH"), so normalize before looking up the score.
export const getPriorityScore = (priorityText: string | undefined | null): number => {
  const key = (priorityText ?? "").toLowerCase().replace("pickup_location_priority_", "");
  return PRIORITY_ORDER[key as keyof typeof PRIORITY_ORDER] || 0;
};

// ─── Status Helpers ─────────────────────────────────────────────────
export const STATUS_ORDER: Record<JobStatus, number> = {
  [JobStatus.JOB_STATUS_UNDEFINED]: 0,
  [JobStatus.JOB_STATUS_CREATED]: 1,
  [JobStatus.JOB_STATUS_ASSIGNED]: 2,
  [JobStatus.JOB_STATUS_ENROUTE]: 3,
  [JobStatus.JOB_STATUS_ON_SERVICE]: 4,
  [JobStatus.JOB_STATUS_COMPLETED]: 5,
  [JobStatus.JOB_STATUS_CANCELLED]: 6,
  [JobStatus.JOB_STATUS_FORCE_COMPLETED]: 7,
  [JobStatus.JOB_STATUS_NOT_COMPLETED]: 8,
  [JobStatus.UNRECOGNIZED]: 999,
} as const;

// ─── Author Helpers ─────────────────────────────────────────────────

export const getUserName = (user?: Pick<ConnectProto.User, "firstName" | "lastName">): string =>
  fullName(user) || "—";

export const getAuthorName = (row: OrderRow): string => {
  const author = row.job?.author as any;
  // Handle both camelCase (gRPC) and snake_case (REST)
  return getUserName({
    firstName: author?.firstName || author?.first_name || "",
    lastName: author?.lastName || author?.last_name || "",
  });
};

export const getAuthorInitials = (row: OrderRow): string => getInitials(getAuthorName(row));

// ─── Job Helpers ────────────────────────────────────────────────────

/** «8 кубовый x 1»: the job's container type, from its container group, and how many it takes. */
export const jobContainerLabel = (job: ConnectProto.Job): string | undefined => {
  const name = job.containerGroup?.containerType?.name;
  if (!name) return undefined;
  return job.numberOfContainers ? `${name} x ${job.numberOfContainers}` : name;
};
